import React, { Component } from "react";
import { CircularProgress } from "../../..";
import { Alert } from "reactstrap";
import style from "./Precheck.module.scss";

class Validation extends Component {
  render() {
    const { validation } = this.props;

    return (
      <div>
        <div className={style.validation}>
          <p>{validation.ValidationName}</p>

          {validation.status ? (
            <span style={{ marginRight: "2px" }}>
              {" "}
              <i className={`${getIconName(validation.status)} icons font-xl d-block`}></i>
            </span>
          ) : (
            <CircularProgress sm style={{ margin: "0px" }} />
          )}
        </div>
        {validation.title && (
          <Alert color={`${getAlertColor(validation.status)}`} className={style.alert}>
            {validation.title}
          </Alert>
        )}
      </div>
    );
  }
}

const getAlertColor = (status) => {
  switch (status) {
    case "success":
      return "success";
    case "failed":
      return "danger";
    case "authorization":
      return "warning";
    case "warningmessage":
      return "warning";
  }
};

const getIconName = (status) => {
  switch (status) {
    case "success":
      return "icon-check";
    case "failed":
      return "icon-close";
    case "authorization":
      return "icon-exclamation";
    case "warningmessage":
      return "icon-exclamation";
  }
};

export default Validation;
